<template>
    <div class="wrap viewed-products-plug">
        <div class="h4 section-title">
            {{ trans('home.viewed_products') }}
        </div>
        <div class="products-amount">
            
            <div class="row">
                <div class="col col-6 col-md-3" v-for="item in products" :key="item.id">
                    <div class="card card-sm desktop-card">
                        <product_item :item="item"></product_item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "./mixins/helper";
import product_item from "./inc/ProductItem";

export default {
    mixins: [helper],
    components: {
        product_item
    },
    props: {
        current:{
            default: 0,
            required: false
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    updated() {
    },
    computed: {
        products: function () {
            console.log(this.$store.state.viewed_products);
            let products = this.$store.state.viewed_products;
            products = products.filter(item => item.id != this.current);
            products = products.slice(0, 4);
            return products;
        }
    },
    methods: {
    }
}
</script>
